module.exports = __webpack_public_path__ + "static/media/Plus.94465f4c.svg";